export { default as winScreen } from "./winScreen";
